import React from 'react';
import { Row, Col, Switch, TimePicker, Typography } from 'antd';
import moment from 'moment';

const { Text } = Typography;

const DayScheduleRow = ({ day, label, value, onChange, disabled = false }) => {
  const isOpen = value?.is_open || false;
  const openTime = value?.open_time ? moment(value.open_time, 'HH:mm') : null;
  const closeTime = value?.close_time ? moment(value.close_time, 'HH:mm') : null;

  const handleSwitchChange = (checked) => {
    onChange({
      is_open: checked,
      open_time: checked ? '09:00' : null,
      close_time: checked ? '18:00' : null,
    });
  };

  const handleTimeChange = (field, time) => {
    onChange({
      ...value,
      [field]: time ? time.format('HH:mm') : null,
    });
  };

  return (
    <Row gutter={16} align="middle" style={{ marginBottom: 16 }}>
      <Col xs={24} sm={6} md={5}>
        <Text strong>{label}</Text>
      </Col>
      <Col xs={12} sm={6} md={4}>
        <Switch
          checked={isOpen}
          onChange={handleSwitchChange}
          checkedChildren="Open"
          unCheckedChildren="Closed"
          disabled={disabled}
          aria-label={`Toggle ${label}`}
        />
      </Col>
      <Col xs={12} sm={6} md={7}>
        <TimePicker
          value={openTime}
          onChange={(time) => handleTimeChange('open_time', time)}
          format="HH:mm"
          disabled={disabled || !isOpen}
          placeholder="Open time"
          minuteStep={30}
          style={{ width: '100%' }}
          aria-label={`${label} open time`}
        />
      </Col>
      <Col xs={12} sm={6} md={7}>
        <TimePicker
          value={closeTime}
          onChange={(time) => handleTimeChange('close_time', time)}
          format="HH:mm"
          disabled={disabled || !isOpen}
          placeholder="Close time"
          minuteStep={30}
          style={{ width: '100%' }}
          aria-label={`${label} close time`}
        />
      </Col>
    </Row>
  );
};

export default DayScheduleRow;